import type { GdprConfig } from '../types';

export function createModalHTML(config: GdprConfig): string {
    const t = config.translations;
    const policyLink = config.cookie_policy_link;

    return `<div id="gdprModal" tabindex="-1" aria-hidden="true" class="fixed top-0 left-0 right-0 z-[9999] hidden w-full p-4 overflow-x-hidden overflow-y-auto md:inset-0 h-modal md:h-full shadow-lg">

    <div class="relative w-full h-full max-w-2xl md:h-auto">

        <div class="relative bg-white rounded shadow">

            <div class="flex items-start justify-between p-4 border-b rounded-t text-white bg-blue-700">

                <strong class="fluid-text-base font-semibold">
                    ${t.disclosure}
                </strong>

            </div>

            <div class="p-4 space-y-6">

                <p class="fluid-text-sm leading-relaxed text-neutral-500">
                    ${t.cookie_text} <a href="${policyLink}" title="Cookie policy" class="text-neutral-700 underline">${t.cookie_policy}</a>
                </p>

            </div>

            <div class="flex flex-row flex-wrap basis-full w-full border-t border-gray-200 rounded-b">

                <div class="flex flex-row flex-wrap basis-full w-full xxs:basis-4/12 xxs:w-4/12 justify-start pl-4 pr-4 pb-4 xxs:p-4 order-last xxs:order-first">

                    <button type="button" id="btn-customizer-gdpr" class="block w-full xxs:inline-block xxs:w-auto font-medium rounded fluid-text-sm px-5 py-2.5 text-center text-neutral-500 bg-white hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-gray-200 border border-gray-200 hover:text-neutral-900">
                        ${t.customize}
                    </button>

                </div>

                <div class="flex flex-row flex-wrap basis-full w-full xxs:basis-8/12 xxs:w-8/12 justify-start xxs:justify-end p-4 order-first xxs:order-last">

                    <ul class="flex flex-row flex-wrap basis-full w-full xxs:basis-auto xxs:w-auto list-none">

                        <li class="flex flex-row basis-6/12 w-6/12 xxs:basis-auto xxs:w-auto pr-1">

                            <button type="button" class="btn-dialog-gdpr block w-full justify-center font-medium rounded fluid-text-sm px-5 py-2.5 text-center text-white bg-blue-700 hover:bg-blue-800 focus:ring-0 focus:outline-none" data-action="decline" data-parent="gdprModal">
                                ${t.decline}
                            </button>

                        </li>

                        <li class="flex flex-row basis-6/12 w-6/12 xxs:basis-auto xxs:w-auto pl-1">

                            <button type="button" class="btn-dialog-gdpr block w-full justify-center font-medium rounded fluid-text-sm px-5 py-2.5 text-center text-white bg-blue-700 hover:bg-blue-800 focus:ring-0 focus:outline-none" data-action="accept" data-parent="gdprModal">
                                ${t.accept}
                            </button>

                        </li>

                    </ul>

                </div>

            </div>

        </div>

    </div>

</div>`;
}
